import { InventoryCustomViewFields, InventoryCustomViewKey } from '../constants/inventoryCustomView.constants';
import { ISelectOption } from './selectOption.interface';

export const InventoryCustomViewOptions: ISelectOption[] = [
  {
    id: InventoryCustomViewKey.applicationsRecentlyModified,
    value: InventoryCustomViewKey.applicationsRecentlyModified,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.applicationsRecentlyModified],
  },
  {
    id: InventoryCustomViewKey.automationsRecentlyModified,
    value: InventoryCustomViewKey.automationsRecentlyModified,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.automationsRecentlyModified],
  },
  {
    id: InventoryCustomViewKey.connectionCreatedFromCustomConnector,
    value: InventoryCustomViewKey.connectionCreatedFromCustomConnector,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.connectionCreatedFromCustomConnector],
  },
  {
    id: InventoryCustomViewKey.disabledAutomations,
    value: InventoryCustomViewKey.disabledAutomations,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.disabledAutomations],
  },
  {
    id: InventoryCustomViewKey.disabledConnections,
    value: InventoryCustomViewKey.disabledConnections,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.disabledConnections],
  },
  {
    id: InventoryCustomViewKey.externalIdentities,
    value: InventoryCustomViewKey.externalIdentities,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.externalIdentities],
  },
  {
    id: InventoryCustomViewKey.inactiveUsers,
    value: InventoryCustomViewKey.inactiveUsers,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.inactiveUsers],
  },
  {
    id: InventoryCustomViewKey.newUsersCreation,
    value: InventoryCustomViewKey.newUsersCreation,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.newUsersCreation],
  },
  {
    id: InventoryCustomViewKey.allBuilders,
    value: InventoryCustomViewKey.allBuilders,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.allBuilders],
  },
  {
    id: InventoryCustomViewKey.notInUseConnection,
    value: InventoryCustomViewKey.notInUseConnection,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.notInUseConnection],
  },
  {
    id: InventoryCustomViewKey.automationUsesAiModel,
    value: InventoryCustomViewKey.automationUsesAiModel,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.automationUsesAiModel],
  },
  {
    id: InventoryCustomViewKey.teamsEnvironments,
    value: InventoryCustomViewKey.teamsEnvironments,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.teamsEnvironments],
  },
  {
    id: InventoryCustomViewKey.autonomousAgents,
    value: InventoryCustomViewKey.autonomousAgents,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.autonomousAgents],
  },
  {
    id: InventoryCustomViewKey.declarativeAgents,
    value: InventoryCustomViewKey.declarativeAgents,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.declarativeAgents],
  },
  {
    id: InventoryCustomViewKey.agentsUsingMcp,
    value: InventoryCustomViewKey.agentsUsingMcp,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.agentsUsingMcp],
  },
  {
    id: InventoryCustomViewKey.automationUsesWebhook,
    value: InventoryCustomViewKey.automationUsesWebhook,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.automationUsesWebhook],
  },
  {
    id: InventoryCustomViewKey.automationUsesHttpStepsWithoutAuthentication,
    value: InventoryCustomViewKey.automationUsesHttpStepsWithoutAuthentication,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.automationUsesHttpStepsWithoutAuthentication],
  },
  {
    id: InventoryCustomViewKey.agentTriggers,
    value: InventoryCustomViewKey.agentTriggers,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.agentTriggers],
  },
  {
    id: InventoryCustomViewKey.orgWideAccess,
    value: InventoryCustomViewKey.orgWideAccess,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.orgWideAccess],
  },
  {
    id: InventoryCustomViewKey.publicAccess,
    value: InventoryCustomViewKey.publicAccess,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.publicAccess],
  },
  {
    id: InventoryCustomViewKey.shadowAi,
    value: InventoryCustomViewKey.shadowAi,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.shadowAi],
  },
  {
    id: InventoryCustomViewKey.privilegedAgents,
    value: InventoryCustomViewKey.privilegedAgents,
    displayName: InventoryCustomViewFields[InventoryCustomViewKey.privilegedAgents],
  },
];
